var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrossRedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1759_14869)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.88074 13.0001H6.11901C6.08645 12.993 6.0539 12.9816 6.02109 12.9793C5.10981 12.9175 4.24635 12.6776 3.448 12.2371C1.61654 11.2264 0.496204 9.69023 0.102242 7.63242C0.054936 7.38495 0.0333177 7.1324 0 6.88214C0 6.62831 0 6.37449 0 6.12066C0.00737567 6.08429 0.019075 6.04792 0.0216183 6.0113C0.0849474 5.10434 0.319443 4.2419 0.764018 3.45067C1.96066 1.32037 3.78804 0.165189 6.22761 0.0123342C7.27928 -0.0535381 8.29839 0.144079 9.24298 0.613833C11.5597 1.76596 12.8192 3.64549 12.9886 6.22723C13.0661 7.40835 12.8011 8.5353 12.2263 9.57146C11.2141 11.3966 9.67561 12.5113 7.61983 12.8992C7.37567 12.9452 7.12693 12.9668 6.88048 12.9999L6.88074 13.0001ZM11.9839 6.49835C11.9811 3.47305 9.52886 1.02102 6.50305 1.01822C3.47521 1.01543 1.01301 3.47712 1.01581 6.50445C1.01861 9.52975 3.47089 11.9818 6.49669 11.9846C9.52453 11.9874 11.9867 9.52568 11.9839 6.49835Z",
    fill: "#DE1186"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.00195 3.71436L9.28627 8.99867",
    stroke: "#DE1186",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99854 3.71436L3.71422 8.99867",
    stroke: "#DE1186",
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1759_14869"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.0018,
    height: 13,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossRedIcon);
export default __webpack_public_path__ + "static/media/cross-red-icon.eb169b6e4d5c9b443b461548069ae578.svg";
export { ForwardRef as ReactComponent };